module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('SiteSection', {
    attrs: {
      "sectionId": "section-work",
      "sectionNo": "2",
      "label": "工作環境與福利",
      "title": "WORK AS A SPROUTER"
    }
  }, [_c('Environment'), _vm._v(" "), _c('Welfare')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-3a0e580e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SectionWork.vue
// module id = 670
// module chunks = 0